import { render, staticRenderFns } from "./ProductBrandTable.vue?vue&type=template&id=a55c3618&scoped=true&"
import script from "./ProductBrandTable.vue?vue&type=script&lang=js&"
export * from "./ProductBrandTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55c3618",
  null
  
)

export default component.exports